import * as React from 'react'
import { PropsWithChildren, ReactElement } from 'react'
import { Avatar, AvatarProps, Tooltip } from '@fluentui/react-components'

export default function PersonAvatar(props: PropsWithChildren<AvatarProps>): ReactElement {
    return (
        <Tooltip relationship={'label'} content={props.name} withArrow>
            <Avatar {...props} />
        </Tooltip>
    )
}
